<template>
  <div
    class="name-container text-left"
    :class="{ 'bg-off-white': darkBg }"
  >
    <div
      class="flex items-center justify-between"
      @click="toggleDetails"
    >
      <p class="text-xxs text-dark-gray">
        {{ fullName }}
      </p>
      <img
        class="h-8 w-8"
        :class="{ '-rotate-180 transform': details }"
        src="@/assets/arrow-down-black.svg"
        alt="arrow icon"
      />
    </div>
    <div
      v-if="details"
      class="mt-5"
    >
      <div class="flex">
        <p
          class="mb-4 w-4/12 truncate text-2xs font-bold uppercase text-dark-blue"
        >
          Email
        </p>
        <p class="text-xxs text-body-color">
          {{ email }}
        </p>
      </div>
      <div class="flex">
        <p
          class="mb-4 w-4/12 truncate text-2xs font-bold uppercase text-dark-blue"
        >
          Phone
        </p>
        <p class="text-xxs text-body-color">
          {{ phone }}
        </p>
      </div>
      <div class="flex">
        <p class="w-4/12 truncate text-2xs font-bold uppercase text-dark-blue">
          Approved By
        </p>
        <p class="text-xxs text-body-color">
          {{ approverFullName }} {{ approvedDate }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { formatPhone } from '@/common/validators';
import moment from 'moment';

export default {
  name: 'Company User Card',
  props: {
    request: Object,
    darkBg: {
      default: false,
    },
  },
  data() {
    return {
      details: false,
      roles: ['Standard', 'Admin', 'Test'],
    };
  },
  computed: {
    fullName() {
      return this.request.user.first_name + ' ' + this.request.user.last_name;
    },
    email() {
      return this.request.user.email;
    },
    approverFullName() {
      return (
        this.request.approver.first_name + ' ' + this.request.approver.last_name
      );
    },
    approvedDate() {
      let approvedDate = this.request.approved_at;
      return moment(approvedDate).format('M/D/YY');
    },
    phone() {
      return formatPhone(this.request.user?.phone_e164?.slice(-10));
    },
  },
  methods: {
    toggleDetails() {
      this.details = !this.details;
    },
  },
};
</script>

<style>
.name-container {
  padding: 12px 14px;
}

.delete-button {
  @apply mt-4 w-full cursor-pointer rounded-md border border-gray-over-dark bg-white text-1md text-gray-over-dark;
  padding: 8.5px 0px !important;
}
</style>
